import { type FC, useState } from "react";
import { UserDetailModal } from "@clientFrontend/features/scout/components/UserDetailModal";
import { TextButton } from "@root/shared/components/TextButton";

type Props = {
  fetchUrl: string;
  gaEvent: {
    gaAction: string;
    gaLabel: string;
  };
};

export const ShowUserDetailModalButton: FC<Props> = ({
  fetchUrl,
  gaEvent: { gaAction, gaLabel },
}) => {
  const [isShow, setIsShow] = useState(false);

  const handleOnClick = () => {
    setIsShow(true);
  };

  const handleOnClickClose = () => {
    setIsShow(false);
  };

  return (
    <>
      <TextButton
        size="large"
        rightIconName="arrow-bold-right"
        isBold
        onClick={handleOnClick}
        data-ga-action={gaAction}
        data-ga-label={gaLabel}
      >
        プロフィールの詳細を見る
      </TextButton>
      {isShow && (
        <UserDetailModal
          fetchUrl={fetchUrl}
          isShowScoutButton={false}
          handleOnClickClose={handleOnClickClose}
        />
      )}
    </>
  );
};
